import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isAlterEgo, setIsAlterEgo] = useState(false);

  const toggleAlterEgo = () => {
    setIsAlterEgo(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isAlterEgo, toggleAlterEgo }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
